UNIT InkaDeltagareMainForm;

INTERFACE

USES
   System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
   WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls;

TYPE
   TForm1 = CLASS(TForm)
    WebPanel_GG: TPanel;
    WebPanel_Imka: TPanel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebButton_AnmInka: TButton;
    WebButton_SpelaInka: TButton;
    WebButton_ResInka: TButton;
    WebButton_AnmGG: TButton;
    WebButton_SpelaGG: TButton;
    WebButton_ResGG: TButton;
    WebPanel_SkapaDeltagare: TPanel;
    WebButton_SkapaDeltagare: TButton;
    WebMemo1: TMemo;
    WebLabel1: TLabel;
    procedure WebButton_AnmGGClick(Sender: TObject);
      PROCEDURE WebButton_AnmInkaClick(Sender: TObject);
      PROCEDURE WebButton_SpelaInkaClick(Sender: TObject);
      PROCEDURE WebButton_SkapaDeltagareClick(Sender: TObject);
      PROCEDURE WebButton_ResInkaClick(Sender: TObject);
    procedure WebButton_SpelaGGClick(Sender: TObject);
    procedure WebButton_ResGGClick(Sender: TObject);
   PRIVATE
    { Private declarations }
   PUBLIC
    { Public declarations }
   protected procedure LoadDFMValues; override; END;

VAR
   Form1: TForm1;

IMPLEMENTATION

{$R *.dfm}

procedure TForm1.WebButton_AnmGGClick(Sender: TObject);
begin
Showmessage('Under utveckling' );
 // window.open('https://gg.mic.tf/InkaAnmProject.html', '_blank');
end;

procedure TForm1.WebButton_SpelaGGClick(Sender: TObject);
begin
Showmessage('Under utveckling' );
 //
end;

procedure TForm1.WebButton_ResGGClick(Sender: TObject);
begin
Showmessage('Under utveckling' );
 //
end;

PROCEDURE TForm1.WebButton_AnmInkaClick(Sender: TObject);
BEGIN
 //Application.Navigate('Https://mic.tf/InkaAnmProject.html', TNavigationTarget.ntBlank);
  window.open('https://gg.mic.tf/InkaAnm/InkaAnmProject.html', '_blank');
END;




PROCEDURE TForm1.WebButton_SpelaInkaClick(Sender: TObject);
BEGIN
 //   Application.Navigate('Https://mic.tf/inkauser.html', TNavigationTarget.ntBlank);
   window.open('https://gg.mic.tf/InkaUser/InkaUser_Project.html', '_blank');
END;



PROCEDURE TForm1.WebButton_ResInkaClick(Sender: TObject);
BEGIN
   window.open('https://gg.mic.tf/inkaresultat/inkaResult.html', '_blank');
END;

PROCEDURE TForm1.WebButton_SkapaDeltagareClick(Sender: TObject);
BEGIN
 //Application.Navigate('Https://mic.tf/SkapaIndianProject.html', TNavigationTarget.ntBlank);
   window.open('https://gg.mic.tf/SkapaIndian/SkapaIndianProject.html', '_blank');
END;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel_GG := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebButton_AnmGG := TButton.Create(Self);
  WebButton_SpelaGG := TButton.Create(Self);
  WebButton_ResGG := TButton.Create(Self);
  WebPanel_Imka := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebButton_AnmInka := TButton.Create(Self);
  WebButton_SpelaInka := TButton.Create(Self);
  WebButton_ResInka := TButton.Create(Self);
  WebPanel_SkapaDeltagare := TPanel.Create(Self);
  WebButton_SkapaDeltagare := TButton.Create(Self);
  WebMemo1 := TMemo.Create(Self);

  WebPanel_GG.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebButton_AnmGG.BeforeLoadDFMValues;
  WebButton_SpelaGG.BeforeLoadDFMValues;
  WebButton_ResGG.BeforeLoadDFMValues;
  WebPanel_Imka.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebButton_AnmInka.BeforeLoadDFMValues;
  WebButton_SpelaInka.BeforeLoadDFMValues;
  WebButton_ResInka.BeforeLoadDFMValues;
  WebPanel_SkapaDeltagare.BeforeLoadDFMValues;
  WebButton_SkapaDeltagare.BeforeLoadDFMValues;
  WebMemo1.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 232;
    Height := 636;
    WebPanel_GG.SetParentComponent(Self);
    WebPanel_GG.Name := 'WebPanel_GG';
    WebPanel_GG.Left := 16;
    WebPanel_GG.Top := 245;
    WebPanel_GG.Width := 181;
    WebPanel_GG.Height := 197;
    WebPanel_GG.Caption := 'WebPanel_GG';
    WebPanel_GG.ChildOrder := 5;
    WebPanel_GG.TabOrder := 0;
    WebLabel2.SetParentComponent(WebPanel_GG);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 20;
    WebLabel2.Top := 14;
    WebLabel2.Width := 77;
    WebLabel2.Height := 23;
    WebLabel2.Caption := 'Gubbgolf';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -17;
    WebLabel2.Font.Name := 'Segoe UI';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(WebPanel_GG);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 102;
    WebLabel1.Top := 18;
    WebLabel1.Width := 74;
    WebLabel1.Height := 20;
    WebLabel1.Caption := 'Inte f'#228'rdigt';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebButton_AnmGG.SetParentComponent(WebPanel_GG);
    WebButton_AnmGG.Name := 'WebButton_AnmGG';
    WebButton_AnmGG.Left := 20;
    WebButton_AnmGG.Top := 45;
    WebButton_AnmGG.Width := 145;
    WebButton_AnmGG.Height := 40;
    WebButton_AnmGG.Caption := 'Anm'#228'lan GG';
    WebButton_AnmGG.ChildOrder := 1;
    WebButton_AnmGG.Font.Charset := DEFAULT_CHARSET;
    WebButton_AnmGG.Font.Color := clWindowText;
    WebButton_AnmGG.Font.Height := -16;
    WebButton_AnmGG.Font.Name := 'Segoe UI';
    WebButton_AnmGG.Font.Style := [fsBold];
    WebButton_AnmGG.HeightPercent := 100.000000000000000000;
    WebButton_AnmGG.ParentFont := False;
    WebButton_AnmGG.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton_AnmGG, Self, 'OnClick', 'WebButton_AnmGGClick');
    WebButton_SpelaGG.SetParentComponent(WebPanel_GG);
    WebButton_SpelaGG.Name := 'WebButton_SpelaGG';
    WebButton_SpelaGG.Left := 20;
    WebButton_SpelaGG.Top := 94;
    WebButton_SpelaGG.Width := 145;
    WebButton_SpelaGG.Height := 40;
    WebButton_SpelaGG.Caption := 'Spela GG';
    WebButton_SpelaGG.ChildOrder := 1;
    WebButton_SpelaGG.Font.Charset := DEFAULT_CHARSET;
    WebButton_SpelaGG.Font.Color := clWindowText;
    WebButton_SpelaGG.Font.Height := -16;
    WebButton_SpelaGG.Font.Name := 'Segoe UI';
    WebButton_SpelaGG.Font.Style := [fsBold];
    WebButton_SpelaGG.HeightPercent := 100.000000000000000000;
    WebButton_SpelaGG.ParentFont := False;
    WebButton_SpelaGG.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton_SpelaGG, Self, 'OnClick', 'WebButton_SpelaGGClick');
    WebButton_ResGG.SetParentComponent(WebPanel_GG);
    WebButton_ResGG.Name := 'WebButton_ResGG';
    WebButton_ResGG.Left := 20;
    WebButton_ResGG.Top := 145;
    WebButton_ResGG.Width := 145;
    WebButton_ResGG.Height := 40;
    WebButton_ResGG.Caption := 'Resultat GG';
    WebButton_ResGG.ChildOrder := 3;
    WebButton_ResGG.Font.Charset := DEFAULT_CHARSET;
    WebButton_ResGG.Font.Color := clWindowText;
    WebButton_ResGG.Font.Height := -16;
    WebButton_ResGG.Font.Name := 'Segoe UI';
    WebButton_ResGG.Font.Style := [fsBold];
    WebButton_ResGG.HeightPercent := 100.000000000000000000;
    WebButton_ResGG.ParentFont := False;
    WebButton_ResGG.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton_ResGG, Self, 'OnClick', 'WebButton_ResGGClick');
    WebPanel_Imka.SetParentComponent(Self);
    WebPanel_Imka.Name := 'WebPanel_Imka';
    WebPanel_Imka.Left := 16;
    WebPanel_Imka.Top := 28;
    WebPanel_Imka.Width := 181;
    WebPanel_Imka.Height := 193;
    WebPanel_Imka.Caption := 'WebPanel1';
    WebPanel_Imka.ChildOrder := 5;
    WebPanel_Imka.TabOrder := 1;
    WebLabel3.SetParentComponent(WebPanel_Imka);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 24;
    WebLabel3.Top := 12;
    WebLabel3.Width := 34;
    WebLabel3.Height := 23;
    WebLabel3.Caption := 'Inka';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -17;
    WebLabel3.Font.Name := 'Segoe UI';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebButton_AnmInka.SetParentComponent(WebPanel_Imka);
    WebButton_AnmInka.Name := 'WebButton_AnmInka';
    WebButton_AnmInka.Left := 20;
    WebButton_AnmInka.Top := 41;
    WebButton_AnmInka.Width := 145;
    WebButton_AnmInka.Height := 40;
    WebButton_AnmInka.Caption := 'Anm'#228'lan Inka';
    WebButton_AnmInka.ChildOrder := 1;
    WebButton_AnmInka.Font.Charset := DEFAULT_CHARSET;
    WebButton_AnmInka.Font.Color := clWindowText;
    WebButton_AnmInka.Font.Height := -16;
    WebButton_AnmInka.Font.Name := 'Segoe UI';
    WebButton_AnmInka.Font.Style := [fsBold];
    WebButton_AnmInka.HeightPercent := 100.000000000000000000;
    WebButton_AnmInka.ParentFont := False;
    WebButton_AnmInka.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton_AnmInka, Self, 'OnClick', 'WebButton_AnmInkaClick');
    WebButton_SpelaInka.SetParentComponent(WebPanel_Imka);
    WebButton_SpelaInka.Name := 'WebButton_SpelaInka';
    WebButton_SpelaInka.Left := 20;
    WebButton_SpelaInka.Top := 87;
    WebButton_SpelaInka.Width := 145;
    WebButton_SpelaInka.Height := 40;
    WebButton_SpelaInka.Caption := 'Spela Inka';
    WebButton_SpelaInka.ChildOrder := 1;
    WebButton_SpelaInka.Font.Charset := DEFAULT_CHARSET;
    WebButton_SpelaInka.Font.Color := clWindowText;
    WebButton_SpelaInka.Font.Height := -16;
    WebButton_SpelaInka.Font.Name := 'Segoe UI';
    WebButton_SpelaInka.Font.Style := [fsBold];
    WebButton_SpelaInka.HeightPercent := 100.000000000000000000;
    WebButton_SpelaInka.ParentFont := False;
    WebButton_SpelaInka.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton_SpelaInka, Self, 'OnClick', 'WebButton_SpelaInkaClick');
    WebButton_ResInka.SetParentComponent(WebPanel_Imka);
    WebButton_ResInka.Name := 'WebButton_ResInka';
    WebButton_ResInka.Left := 20;
    WebButton_ResInka.Top := 133;
    WebButton_ResInka.Width := 145;
    WebButton_ResInka.Height := 40;
    WebButton_ResInka.Caption := 'Resultat Inka';
    WebButton_ResInka.ChildOrder := 3;
    WebButton_ResInka.Font.Charset := DEFAULT_CHARSET;
    WebButton_ResInka.Font.Color := clWindowText;
    WebButton_ResInka.Font.Height := -16;
    WebButton_ResInka.Font.Name := 'Segoe UI';
    WebButton_ResInka.Font.Style := [fsBold];
    WebButton_ResInka.HeightPercent := 100.000000000000000000;
    WebButton_ResInka.ParentFont := False;
    WebButton_ResInka.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton_ResInka, Self, 'OnClick', 'WebButton_ResInkaClick');
    WebPanel_SkapaDeltagare.SetParentComponent(Self);
    WebPanel_SkapaDeltagare.Name := 'WebPanel_SkapaDeltagare';
    WebPanel_SkapaDeltagare.Left := 16;
    WebPanel_SkapaDeltagare.Top := 464;
    WebPanel_SkapaDeltagare.Width := 181;
    WebPanel_SkapaDeltagare.Height := 145;
    WebPanel_SkapaDeltagare.ChildOrder := 2;
    WebPanel_SkapaDeltagare.TabOrder := 2;
    WebButton_SkapaDeltagare.SetParentComponent(WebPanel_SkapaDeltagare);
    WebButton_SkapaDeltagare.Name := 'WebButton_SkapaDeltagare';
    WebButton_SkapaDeltagare.Left := 20;
    WebButton_SkapaDeltagare.Top := 80;
    WebButton_SkapaDeltagare.Width := 145;
    WebButton_SkapaDeltagare.Height := 45;
    WebButton_SkapaDeltagare.Hint := 'Om du inte registrerat dig tidigare klicka h'#246'r';
    WebButton_SkapaDeltagare.Caption := 'Registrera dig';
    WebButton_SkapaDeltagare.ChildOrder := 2;
    WebButton_SkapaDeltagare.Font.Charset := DEFAULT_CHARSET;
    WebButton_SkapaDeltagare.Font.Color := clWindowText;
    WebButton_SkapaDeltagare.Font.Height := -16;
    WebButton_SkapaDeltagare.Font.Name := 'Segoe UI';
    WebButton_SkapaDeltagare.Font.Style := [fsBold];
    WebButton_SkapaDeltagare.HeightPercent := 100.000000000000000000;
    WebButton_SkapaDeltagare.ParentFont := False;
    WebButton_SkapaDeltagare.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton_SkapaDeltagare, Self, 'OnClick', 'WebButton_SkapaDeltagareClick');
    WebMemo1.SetParentComponent(WebPanel_SkapaDeltagare);
    WebMemo1.Name := 'WebMemo1';
    WebMemo1.Left := 20;
    WebMemo1.Top := 16;
    WebMemo1.Width := 148;
    WebMemo1.Height := 23;
    WebMemo1.AllowResize := True;
    WebMemo1.AutoSize := True;
    WebMemo1.Font.Charset := DEFAULT_CHARSET;
    WebMemo1.Font.Color := clWindowText;
    WebMemo1.Font.Height := -12;
    WebMemo1.Font.Name := 'Segoe UI';
    WebMemo1.Font.Style := [];
    WebMemo1.HeightPercent := 100.000000000000000000;
    WebMemo1.Lines.BeginUpdate;
    try
      WebMemo1.Lines.Clear;
      WebMemo1.Lines.Add('En f'#246'rsta g'#229'ng m'#229'ste du registrera dig');
      WebMemo1.Lines.Add('Klicka p'#229' Registrera dig');
    finally
      WebMemo1.Lines.EndUpdate;
    end;
    WebMemo1.ParentFont := False;
    WebMemo1.SelLength := 0;
    WebMemo1.SelStart := 66;
    WebMemo1.WidthPercent := 100.000000000000000000;
  finally
    WebPanel_GG.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebButton_AnmGG.AfterLoadDFMValues;
    WebButton_SpelaGG.AfterLoadDFMValues;
    WebButton_ResGG.AfterLoadDFMValues;
    WebPanel_Imka.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebButton_AnmInka.AfterLoadDFMValues;
    WebButton_SpelaInka.AfterLoadDFMValues;
    WebButton_ResInka.AfterLoadDFMValues;
    WebPanel_SkapaDeltagare.AfterLoadDFMValues;
    WebButton_SkapaDeltagare.AfterLoadDFMValues;
    WebMemo1.AfterLoadDFMValues;
  end;
end;

END.

